import React from "react";

/**
 * Small labelled panel used by both SEO sub-tabs.
 * Extracted from AdminSeo so the sibling panels can share it without importing
 * from the shell (which would create a circular dependency).
 */
const StatCard = ({ label, children }) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
    <p className="text-xs uppercase tracking-wide text-gray-500 font-medium mb-2">{label}</p>
    {children}
  </div>
);

export default StatCard;
